import * as React from 'react';

import SignatureBox from './SignatureBox';

class Agreement extends React.Component {
  render() {
    return (
      <div className="SignatureWrapper"> 
        <div className="alert-message">
          <SignatureBox inputName="job[giftaid_signature]" />
        </div>
      </div>
    );
  }
}


type Props = {
  status: string,
}


class WidgetGiftaid extends React.Component<Props> {
  state = {
    status: this.props.status,
  };

  onChangeStatus = (e) => {
    this.setState({
      status: e.target.value,
    })
  }

  render() {
    const needsSignature = this.state.status == 'BOXMOVE_ENROLLED';
    return (
      <div className="WidgetGiftaid ml-2">
        <div className="form-group" onChange={this.onChangeStatus}>
          <label>
            <input type="radio" name="job[giftaid_status]" value="BOXMOVE_ENROLLED" id="giftaid_yes" />&nbsp;Yes, add Gift Aid
          </label>
        </div>

        {needsSignature && <Agreement />}

        <div className="form-group" onChange={this.onChangeStatus}>
          <label>
            <input type="radio" name="job[giftaid_status]" value="NOT_INTERESTED" />&nbsp;No, do not add Gift Aid
          </label>
        </div>
      </div>
    );
  }
}

export default WidgetGiftaid;
